import { render, staticRenderFns } from "./shoppingList.vue?vue&type=template&id=1f48dbc1&scoped=true"
import script from "./shoppingList.vue?vue&type=script&lang=js"
export * from "./shoppingList.vue?vue&type=script&lang=js"
import style0 from "./shoppingList.vue?vue&type=style&index=0&id=1f48dbc1&prod&lang=scss&scoped=true"
import style1 from "./shoppingList.vue?vue&type=style&index=1&id=1f48dbc1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f48dbc1",
  null
  
)

export default component.exports